export default __webpack_public_path__ + "static/media/image-board-study-pattern-n-m.38cc36b4.webp";